const urls = {
  config: 'config/app/v1',
  account: 'account/v1',
  adminStore: 'account/admin-store/v1',
  adminStoreNote: 'account/admin-store/v1/notes',
  category: 'combo/category/v1',
  user: 'account/user/v1',
  product: 'product/v1',
  locale: 'combo/locale/v1',
  location: 'combo/location/v1',
  currency: 'combo/currency/v1',
  country: 'combo/country/v1',
  ribbon: 'combo/ribbon/v1',
  storeType: 'combo/store-type/v1',
  adPlacement: 'combo/ad-placement/v1',
  role: 'role/v1',
  attachment: 'attachment/v1',
  attachmentGroup: 'attachment/group/v1',
  homePage: 'page/home/v1',
  webPage: 'page/web/v1',
  winItem: 'page/win-item/v1',
  winItemWinner: 'page/win-item/{winItemId}/winner/v1',
  winItemParticipant: 'page/win-item/{winItemId}/participant/v1',
  userNotification: 'notification/account/v1',
  sendNotification: 'notification/send/v1',
  issue: 'issue/issue/v1',
  predefinedIssue: 'issue/predefined/v1',
  dashboard: 'dashboard/v1',
  report: 'report/v1',
  reportView: 'report/view/v1',
  contactUs: 'contactus/v1',
  apiRequestLogs: 'system/logs/api-request/v1',
  auditLogs: 'system/logs/audit/v1',
  jobs: 'system/jobs/v1',
  failedJobs: 'system/failed-jobs/v1',
  faq: 'config/faq/v1',
  expense: 'expense/v1',
  paymentMethod: 'payment/method/v1',
  paymentProvider: 'payment/provider/v1',
  export: 'export/v1',
  import: 'import/v1',
  paymentHistory: 'tenant/payment-history/v1',
  chat: 'chat/v1',
  chatMsg: 'chat/msg/v1',
  adsPackage: 'package/ads/v1',
  productPackage: 'package/product/v1',
  storePackage: 'package/store/v1',
  storeAdsPackage: 'store/package/ads/v1',
  storeProductPackage: 'store/package/product/v1',
  store: 'store/v1',
  bannerPackage: 'package/banner/v1',
  notificationPackage: 'package/notification/v1',
  boostProductPackage: 'package/boost-product/v1',
  boostStorePackage: 'package/boost-store/v1',
  bannerSubscription: 'store/subscription/banner/v1',
  boostProductSubscription: 'store/subscription/boost-product/v1',
  boostStoreSubscription: 'store/subscription/boost-store/v1',
  notificationSubscription: 'store/subscription/notification/v1',
  productSubscription: 'store/subscription/product/v1',
  storeSubscription: 'store/subscription/store/v1',
  bannerUsage: 'store/usage/banner/v1',
  boostProductUsage: 'store/usage/boost-product/v1',
  boostStoreUsage: 'store/usage/boost-store/v1',
  notificationUsage: 'store/usage/notification/v1',
  productUsage: 'store/usage/product/v1',
  onlinePayment: 'payment/online/v1',
  ingest: 'ingest/v1',
};
export const BaseUrl = {
  get: name => urls[name],
};
